import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Pages from "../../constant/ReportModel";
import {
  setSelectedProjectdata,
  setSelectedsite,
  setSelectedSiteId,
  setShowmapmodal,
  setShowReport
} from "../../redux/actions/actions";
import {
  Box,
  Button,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import Emptydata from "../common/Emptydata";
import Loader from "../../common/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import VerifiedIcon from "@mui/icons-material/Verified";
import { BIGrey, BIRed, BIBlue } from "../../assets/helpers";
import AddCompanyWithRole from "../common/AddCompanyWithRole";
import { FETCH_PROJECT_SITE_COMPANIES } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { English } from "../../constant/EnglishFallback";
import { CompanyListSkeleton } from "../skeleton/SkeletonView";

const SitesCompanySection = ({ siteId, scrollId, activeTab }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loginData, multiLanguageData, reportSuccess, reportData } = useSelector(
    (state) => state?.main
  );
  const LanguageData = multiLanguageData?.SiteDetail || {};
  const {
    TEXT_COMPANIES = English.SiteDetail.TEXT_COMPANIES,
    TEXT_ADD_COMPANY = English.SiteDetail.TEXT_ADD_COMPANY,
    TEXT_NO_COMPANIES_ADDED_YET = English.SiteDetail.TEXT_NO_COMPANIES_ADDED_YET,
    TEXT_REPORT = English.SiteDetail.TEXT_REPORT,
    TEXT_NO_RESULTS_FOUND = English.SiteDetail.TEXT_NO_RESULTS_FOUND
  } = LanguageData || {};

  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const [companyData, setCompanyData] = useState([]);

  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [showAddCompanyModal, setShowAddCompanyModal] = useState(false);
  const [product, setProduct] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [isLoading, setIsloading] = useState(true);
  const [noOfProject, setNoOfProject] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    if (activeTab === "companies" && siteId) {
      callCompanyData();
    }
  }, [activeTab, siteId]);

  const callCompanyData = async () => {
    setIsloading(true);
    setPageNumber(1);
    await getCompanyData(1, "firstTimeApiCall");
    setIsloading(false);
  };

  // after report refresh the only company list
  useEffect(() => {
    if (reportSuccess === true) {
      if (reportData?.AppScreenId === Pages?.companies?.id) {
        let reportObj = {
          showReport: false,
          recordId: 0,
          name: "",
          AppScreenId: 0
        };
        dispatch(setShowReport(reportObj));
        callCompanyData();
      }
    }
  }, [reportSuccess]);

  const getCompanyData = async (pageNumber, firstTimeApiCall) => {
    if (!siteId) return;
    try {
      setAllDataLoaded(true);
      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: currentUserId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [{ SiteId: siteId }],
        SortList: [{ FieldName: "DateCreated", Direction: "DESC" }]
      };
      const res = await Postrequestcall(FETCH_PROJECT_SITE_COMPANIES, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      const totalRecords = res?.data?.nrOfRecords ?? 0;
      setNoOfProject(totalRecords);
      setHasMore(resData.length >= 20 && (pageNumber * 20 < totalRecords || totalRecords === 0));
      if (pageNumber > 1) {
        setTimeout(() => {
          setCompanyData((prevProducts) => [...prevProducts, ...resData]);
        }, 500);
      } else {
        setCompanyData(resData);
        // Set hasData for the first time API call
        if (firstTimeApiCall) {
          setHasData(resData?.length > 0);
        }
      }
    } catch (error) {
      console.log("getCompanyData-> Error While Getting Project Site Company: ", error);
    } finally {
      setShowSearchLaoder(false);
      setAllDataLoaded(false);
      setIsloading(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      recordId: product.companyId ?? 0,
      name: Pages?.companies?.name,
      AppScreenId: Pages?.companies?.id
    };
    dispatch(setShowReport(reportObj));
  };

  const onAddCompanyClick = () => {
    setShowAddCompanyModal(true);
  };

  const onItemClick = (item) => {
    const isMfr =
      item?.manufacturer === true ||
      String(item?.manufacturer).toLowerCase() === "true" ||
      item?.manufacturer === 1 ||
      String(item?.isManufacturer).toLowerCase() === "true" ||
      item?.isManufacturer === true;

    const targetId = item?.companyId;
    if (targetId) {
      if (isMfr) {
        navigate(`/manufacture/${targetId}`);
      } else {
        navigate(`/company/${targetId}`);
      }
    }
    let mapModal = {
      open: false,
      from: "",
      select: ""
    };
    dispatch(setSelectedsite(null));
    dispatch(setShowmapmodal(mapModal));
    dispatch(setSelectedSiteId(0));
    dispatch(setSelectedProjectdata(null));
  };

  const onCompanyClick = (currentTarget, product) => {
    setProduct(product);
    setMoreMenuAnchorEl(currentTarget);
  };

  const increaseOffset = () => {
    if (allDataLoaded || isLoading || !hasMore) return;
    const nextPage = pageNumber + 1;
    setPageNumber(nextPage);
    getCompanyData(nextPage);
  };

  const NoInformation = () => {
    return (
      <Stack  sx={{ gap: 1, height: "100%" }}>
        <Stack sx={{ display: "flex",  justifyContent: "flex-end", alignItems: "center" }}  direction={"row"}>
          {/* Count Removed */}
          <Button
            sx={{ textTransform: "none" }}
            variant="outlined"
            color="primary"
            onClick={onAddCompanyClick}>
            {TEXT_ADD_COMPANY}
          </Button>
        </Stack>
        <Box className="empty-data-card">
          <Emptydata
            icon={<BusinessCenterIcon className="emptydata-icon" />}
            firstText={TEXT_NO_COMPANIES_ADDED_YET}
          />
        </Box>
      </Stack>
    );
  };

  const renderListing = () => {
    return (
      <Stack sx={{ gap: 1 }} >
        <Stack sx={{ display: "flex",  justifyContent: "flex-end", alignItems: "center" }}  direction={"row"}>
          {/* Count Removed */}
          <Button
            sx={{ textTransform: "none" }}
            variant="outlined"
            color="primary"
            onClick={onAddCompanyClick}>
            {TEXT_ADD_COMPANY}
          </Button>
        </Stack>
        <Stack spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : companyData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={companyData?.length}
                next={increaseOffset}
                hasMore={hasMore}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  <Stack sx={{ gap: 1 }} >
                    {companyData.map((item) => (
                      <Card key={item?.id} className="pagelist-content">
                        <ListItem
                          key={item?.id}
                          style={{ padding: "0px" }}
                          secondaryAction={
                            <IconButton
                              onClick={(event) => onCompanyClick(event.currentTarget, item)}>
                              <MoreIcon />
                            </IconButton>
                          }>
                          <ListItemButton
                            onClick={() => {
                              onItemClick(item);
                            }}>
                            <ListItemText
                              primary={
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                  {item?.companyName}
                                  {item?.verified && (
                                    <Tooltip title="This company has been verified" arrow>
                                      <VerifiedIcon sx={{ color: BIBlue, fontSize: "1.1rem", flexShrink: 0 }} />
                                    </Tooltip>
                                  )}
                                </Box>
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    ))}
                  </Stack>
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => setMoreMenuAnchorEl(null)}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {TEXT_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack sx={{ justifyContent: "center", alignItems: "center" }} direction={"row"} style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Stack>
    );
  };

  return (
    <Box>
      {isLoading ? <CompanyListSkeleton /> : hasData ? renderListing() : <NoInformation />}
      {showAddCompanyModal && (
        <AddCompanyWithRole
          open={showAddCompanyModal}
          onClose={() => {
            setShowAddCompanyModal(false);
          }}
          title={TEXT_ADD_COMPANY}
          from={"SiteCard"}
          mainId={siteId}
          onDataSave={async () => {
            setShowAddCompanyModal(false);
            await getCompanyData(1, "firstTimeApiCall");
          }}
        />
      )}
    </Box>
  );
};

export default SitesCompanySection;

